import AutorenewIcon from '@mui/icons-material/Autorenew'
import React, { ReactNode, useCallback, useState } from 'react'
import { Button, useNotify, useRefresh } from 'react-admin'
import { getUrl, httpClient } from '../../providers/data'

interface RenewCertificateButtonProps {
  certificateId?: string
  label?: string
  renderAs?: (onClick: () => void, loading: boolean) => ReactNode
}

const RenewCertificateButton: React.FC<RenewCertificateButtonProps> = ({
  certificateId,
  label = 'resources.certificates.actions.renew',
  renderAs,
}) => {
  const notify = useNotify()
  const refresh = useRefresh()
  const [loading, setLoading] = useState(false)

  const onClick = useCallback(() => {
    setLoading(true)
    httpClient(`${getUrl()}/certificate/${certificateId}/renew`, {
      method: 'POST',
    })
      .then(() => {
        notify('resources.certificates.actions.renewSuccess', { type: 'info' })
        refresh()
      })
      .catch((e: unknown) => {
        console.error(e)
        notify('ra.notification.http_error', { type: 'warning' })
      })
      .finally(() => setLoading(false))
  }, [certificateId, notify, refresh])

  if (renderAs) return <>{renderAs(onClick, loading)}</>

  return (
    <Button
      label={label}
      variant="contained"
      startIcon={<AutorenewIcon />}
      onClick={onClick}
      disabled={loading}
    />
  )
}

export default RenewCertificateButton
